export default __webpack_public_path__ + "static/3-min-7473c289d9e2654091a1a3c236c1e62f.png";